const namespace = 'FEEDBACKS';
export const ACTION_TYPES = {
    SET_FEEDBACKS: `${namespace}/SET_FEEDBACKS`,
    TOGGLE_IS_POSITIVE: `${namespace}/TOGGLE_IS_POSITIVE`,
    SET_IS_POSITIVE: `${namespace}/SET_IS_POSITIVE`,
    SET_IS_ITEM_NOT_RECEIVED: `${namespace}/SET_IS_ITEM_NOT_RECEIVED`,
    SET_COMMENT: `${namespace}/SET_COMMENT`,
    SET_RATING: `${namespace}/SET_RATING`
};

export const setFeedbacks = payload => ({
    type: ACTION_TYPES.SET_FEEDBACKS,
    payload
});

/**
 * If previously null, isPositive value becomes the given value.
 * If previously true, isPositive becomes null if given true or false if given false.
 * If previously false, isPositive becomes null if given false or true if given true.
 * @param {*} transactionId
 * @param {*} isPositive
 * @returns
 */
export const toggleIsPositive = (transactionId, isPositive) => ({
    type: ACTION_TYPES.TOGGLE_IS_POSITIVE,
    payload: { transactionId, isPositive }
});

export const setComment = (transactionId, comment) => ({
    type: ACTION_TYPES.SET_COMMENT,
    payload: { transactionId, comment }
});

export const setRating = (transactionId, ratingName, rating) => ({
    type: ACTION_TYPES.SET_RATING,
    payload: { transactionId, rating, ratingName }
});

export const setItemNotReceived = (transactionId, isItemNotReceived) => ({
    type: ACTION_TYPES.SET_IS_ITEM_NOT_RECEIVED,
    payload: { transactionId, isItemNotReceived }
});
